<template>
    <modal id="print-calendar-modal"
            title="Print Calendar"
            :visible="show"         
            :scrollable="false"
            ok-title="Download"
            @ok="downloadCalendar"
            class="lx-global-modal"
            body-class="lx-print-modal-body"
            no-fade>
        <b-row>
            <b-col>
                <label for="calendar-print-modal-datepicker">Starting Date:</label>
                <datepicker
                id="calendar-print-modal-datepicker"
                v-model="startingDate"
                :display-format="userUnicodeDateFormat"
                class="mb-2">
               </datepicker>
            </b-col>
        </b-row>       
        <b-row>
            <b-col>
                <label for="calendar-print-modal-period">Period:</label>
                <b-form-select v-model="selectedPeriod" :options="selectedPeriodOptions" class="mb-2"></b-form-select>
            </b-col>
        </b-row>             
    </modal>

</template>

<script>
    import { mapGetters } from 'vuex';
    import format from 'date-fns/format';
    import parseISO from 'date-fns/parseISO';
    import Datepicker from '../../generic/datepicker/datepicker.vue';
    import Modal from '../../generic/modal/modal.vue';

    export default {
        name: 'PrintCalendarModal',
        components: {
            Datepicker,
            Modal
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                startingDate: format(new Date(), 'yyyy-MM-dd'),
                selectedPeriod: '2_WEEK',
                selectedPeriodOptions: [
                    { value: 'MONTH', text: 'Month' },
                    { value: '1_WEEK', text: '1 Week' },
                    { value: '2_WEEK', text: '2 Weeks' },
                ],              
            }
        },
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
        },
        methods: {
            downloadCalendar() {
                var date = format(parseISO(this.startingDate), 'yyyy-MM-dd');
                window.location = `/system/pdf-calendar/download/?start_date=${date}&period=${this.selectedPeriod}`;
            }
        },
    }
</script>

<style lang="scss" scoped>
    
</style>
